// This is not yet a complete store for lab-related state, but it can
// be used to hold lab-specific information that is not available in any
// other existing redux store.  It also holds useful state for newer labs
// that use LabContainer.
var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    isLoading: false,
    isPageError: false,
};
var labSlice = createSlice({
    name: 'lab',
    initialState: initialState,
    reducers: {
        setIsLoading: function (state, action) {
            state.isLoading = action.payload;
        },
        setIsPageError: function (state, action) {
            state.isPageError = action.payload;
        },
    },
});
export var setIsLoading = (_a = labSlice.actions, _a.setIsLoading), setIsPageError = _a.setIsPageError;
export default labSlice.reducer;
